import "./search-result.style.scss";

import { Hr, Row, View } from "@amzn/stencil-react-components/layout";
import { getTaxonomyPath } from "@/common/helpers/taxonomy.util";
import { SearchResultProps } from "@/common/types/search-types";
import React, { FC } from "react";
import { Link } from "react-router-dom";

import { ProductInfo } from "./product-info";

export const SearchResult: FC<SearchResultProps> = (props: SearchResultProps) => {
  const detailsPath = `/items/${getTaxonomyPath(props.taxonomyId)}`;

  return (
    <View data-cy="catalog-product-result" dataTestId="catalog-product-result">
      <View margin={["32px", "0"]} padding="S300">
        <Link
          to={detailsPath}
          style={{ textDecoration: "none", color: "inherit", display: "block" }}
          data-testid="search-result-link"
        >
          <Row gridGap="48px" justifyContent="space-between">
            <ProductInfo
              name={props.name}
              logoUrl={props.logoUrl}
              shortDescription={props.shortDescription}
            />
            {/* TODO: Uncomment once migration is complete and shown to stakeholders — revisit price/labels visibility */}
            {/* <ProductPrice price={props.price} /> */}
            {/* <ProductLabels etaDays={props.etaDays} os={props.os} /> */}
          </Row>
        </Link>
      </View>
      <Hr />
    </View>
  );
};
